let appBridge = null;

const createLogger = () => {
  const { logger, http, webvitals, logUnhandledErrors, Console } =
    window.emuiDiagnostics || {};
  if (logger) {
    const appLogger = logger({
      transport: http('https://int.api.ellielabs.com/diagnostics/v2/logging'),
      // transport: Console(),
      index: 'appbridge',
      team: 'ui platform',
      appName: 'Micro FrontEnd Factory Demo',
    });

    webvitals(appLogger);
    logUnhandledErrors(appLogger);
    appLogger.info('Micro FrontEnd Factory launched');
    return appLogger;
  }
  console.warn('ui logger missing'); // eslint-disable-line no-console
};

export const getAppBridge = async () => {
  if (appBridge) return appBridge;
  const appLogger = createLogger();
  const aBridge = new ice.CAppBridge({ logger: appLogger });
  await aBridge.init();
  appBridge = aBridge;
  return appBridge;
};

export const getWindow = () => {
  let winObj = window;
  try {
    // eslint-disable-next-line no-unused-expressions
    window.parent.document;
    winObj = window.parent;
  } catch (err) {
    /* empty */
  }
  return winObj;
};


document.addEventListener('error', (event) => {
  console.error('Error in iframe:', event);
});

document.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled rejection in iframe:', event.reason);
});

export const floatEquals = (num1, num2, epsilon = 0.0001) =>
  Math.abs(num1 - num2) < epsilon;

export const registerApp = ({ browserWindow, appId, app }) => {
  if (!app?.uuid) throw new Error('application uuid is required');
  browserWindow.emui[appId] = browserWindow.emui[appId] || [];
  if (Array.isArray(browserWindow.emui[appId])) {
    const appIndex = browserWindow.emui[appId].findIndex(
      (eApp) => eApp.uuid === app.uuid,
    );
    if (appIndex > -1) {
      browserWindow.emui[appId][appIndex] = app;
    } else {
      browserWindow.emui[appId].push(app);
    }
  } else {
    let existingApp = browserWindow.emui[appId];
    if (existingApp?.uuid === app.uuid) {
      existingApp = { ...existingApp, ...app };
      browserWindow.emui[appId] = [existingApp];
    } else if (typeof existingApp.init === 'undefined') {
      browserWindow.emui[appId] = [{ ...existingApp, ...app }];
    } else {
      browserWindow.emui[appId] = [browserWindow.emui[appId], app];
    }
  }
};

export const setFrameSize = ({ host, appId }) => {
  const { document } = window;
  const iframeBody = document.body;
  const iframeHTML = document.documentElement;
  const size = {
    height: Math.max(
      iframeBody.scrollHeight,
      iframeBody.offsetHeight,
      iframeHTML.offsetHeight,
    ),
    width: Math.max(
      iframeBody.scrollWidth,
      iframeBody.offsetWidth,
      iframeHTML.offsetWidth,
    ),
  };
  host.setAppWindowSize?.({
    appId,
    size,
  });
};
